import PropTypes from 'prop-types';
import React from 'react';

import { contentfulViews } from '@glowforge/ui-common';

const { TextSection } = contentfulViews;

const ReferralMain = props => (
  <TextSection
    {...props.mainPageContent}
    headerClass='h1'
    className='content' />
);

ReferralMain.propTypes = {
  mainPageContent: PropTypes.shape(TextSection.propTypes).isRequired,
};

export default ReferralMain;



// WEBPACK FOOTER //
// ./app/components/support/referral/main.jsx